<template>
  <div class="page padding">
    <b-row>
      <b-col md="6" class="body">
        <img v-bind:src="'img/icons/RC/RC_1.1.svg'" class="icon" />
        <p>Rc Profesional</p>
        <p>Flyers de Descripción de Coberturas</p>
        <p>Instituciones y profesionales de la salud</p>
        <b-button class="button" style="background-color: #0081bb" @click="openPDF('PROFESIONALES INDIVIDUALES/Médicos Individuales.pdf')">MEDICOS INDIVIDUALES</b-button><br />

        <b-button v-b-toggle.instituciones_medicas class="button" style="background-color: #0081bb">INSTITUCIONES MÉDICAS</b-button><br />
        <b-collapse id="instituciones_medicas">
          <b-button class="button" v-for="(item, index) in instituciones_medicas" :key="index" @click="openPDF('INSTITUCIONES/' + item.link)">{{ item.text }}</b-button
          ><br />
        </b-collapse>

        <b-button v-b-toggle.otras_profesiones class="button" style="background-color: #00aae7">OTRAS PROFESIONES</b-button><br />
        <b-collapse id="otras_profesiones">
          <b-button class="button" v-for="(item, index) in otras_profesiones" :key="index" @click="openPDF('PROFESIONALES INDIVIDUALES/' + item.link)">{{ item.text }}</b-button
          ><br />
        </b-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdf_url: 'http://nobleonline.nobleseguros.com/be/recursos/RCP/',
      instituciones_medicas: [
        { text: 'Instituciones', link: 'Instituciones.pdf' },
        { text: 'Cirugía Plástica', link: 'Cirugía Plástica.pdf' },
        { text: 'Clínica y Sanatorios', link: 'Clínica y Sanatorios.pdf' },
        { text: 'Diagnóstico por Imágenes', link: 'Diagnóstico por Imágenes.pdf' },
        { text: 'Diálisis', link: 'Diálisis.pdf' },
        { text: 'Farmacias', link: 'Farmacias.pdf' },
        { text: 'Ginecología', link: 'Ginecología.pdf' },
        { text: 'Instituciones - Oftalmología', link: 'Instituciones - Oftalmología.pdf' },
        { text: 'Laboratorios', link: 'Laboratorios.pdf' },
        { text: 'Medicina Laboral', link: 'Medicina Laboral.pdf' },
        { text: 'Odontología', link: 'Odontología.pdf' },
        { text: 'Ortopedia y Traumatología', link: 'Ortopedia y Traumatología.pdf' },
        { text: 'Pediatría', link: 'Pediatría.pdf' },
        { text: 'Psiquiatría', link: 'Psiquiatría.pdf' },
      ],
      otras_profesiones: [
        { text: 'Acompañante Terapéutico', link: 'Acompañante Terapéutico.pdf' },
        { text: 'Agentes de Belleza', link: 'Agentes de Belleza.pdf' },
        { text: 'Auxiliares de la Medicina', link: 'Auxiliares de la Medicina.pdf' },
        { text: 'Bioquímicos', link: 'Bioquímicos.pdf' },
        { text: 'Cirugía Plástica', link: 'Cirugía Plástica.pdf' },
        { text: 'Enfermeros', link: 'Enfermeros.pdf' },
        { text: 'Farmacéuticos', link: 'Farmacéuticos.pdf' },
        { text: 'Fonoaudiólogo', link: 'Fonoaudiólogo.pdf' },
        { text: 'Kinesiólogos', link: 'Kinesiólogos.pdf' },
        { text: 'Maestra Integradora', link: 'Maestra Integradora.pdf' },
        { text: 'Médicos Individuales', link: 'Médicos Individuales.pdf' },
        { text: 'Musicoterapeuta', link: 'Musicoterapeuta.pdf' },
        { text: 'Odontólogos', link: 'Odontólogos.pdf' },
        { text: 'Oftalmólogos', link: 'Oftalmólogos.pdf' },
        { text: 'Ópticos', link: 'Ópticos.pdf' },
        { text: 'Ortopedia y Traumatología', link: 'Ortopedia y Traumatología.pdf' },
        { text: 'Pòdólogos', link: 'Pòdólogos.pdf' },
        { text: 'Psicólogos', link: 'Psicólogos.pdf' },
        { text: 'Psicopedagogo', link: 'Psicopedagogo.pdf' },
        { text: 'Reumatólogo', link: 'Reumatólogo.pdf' },
      ],
    };
  },

  methods: {
    openPDF(pdf) {
      window.open(this.pdf_url + pdf);
    },
  },
};
</script>

<style scoped>
.body {
  color: #0081bb;
  max-width: 400px;
  font-weight: bold;
  font-size: 12pt;
}
.icon {
  filter: invert(29%) sepia(100%) saturate(3414%) hue-rotate(180deg) brightness(96%) contrast(101%);
  width: 60%;
  margin-bottom: 15px;
}

@media (max-width: 576px) {
  .icon {
    margin-right: auto;
    display: block;
    margin-left: auto;
    width: 50%;
    margin-bottom: 15px;
  }
}

.button {
  width: 100%;
  text-align: left;
  font-weight: bold;
}

.button:hover{
  color:#ffffff;
}
</style>